export const spacers = {
    sm: "28px",
    md: "44px",
    lg: "56px",
    xl: "88px",
};
